import { SInfiniteLoader } from './InfiniteLoader.styled'
import { IntersectionOptions, useInView } from 'react-intersection-observer'
import { BlockSpinner } from 'components/spinner/Spinner'
import { ReactElement, useEffect } from 'react'
import { PaginationMetaData } from 'utils/pagination'

export const InfiniteLoader = (props: {
  className?: string
  customSpinner?: ReactElement
  metaData: PaginationMetaData
  options?: IntersectionOptions
}) => {
  const { ref, inView } = useInView(props.options)
  const { handleLoadMore, isReachingEnd, isLoadingMore } = props.metaData

  useEffect(() => {
    if (inView && !isReachingEnd && !isLoadingMore && handleLoadMore) {
      handleLoadMore()
    }
  }, [inView, isReachingEnd, handleLoadMore, isLoadingMore])

  return (
    <SInfiniteLoader className={props.className} ref={ref}>
      {isLoadingMore && (props.customSpinner || <BlockSpinner />)}
    </SInfiniteLoader>
  )
}
